import React from "react";
import Loader from "components/loader/Loader";
import "./Loading.scss";

function Loading(props) {
  const { visible } = { ...props };

  if (!visible) return null;

  return (
    <div className="loading-container-screen">
      <div className="vertical-center">
        <Loader visible={visible} className={"loading"} />
      </div>
    </div>
  );
}

export default Loading;
